/* eslint-disable @typescript-eslint/no-empty-function */

interface IContentSectionLabeledCountersProps {
  counters: {
    label: string;
    totalCount: number;
  }[];
}

function ContentSectionLabeledCounters({ counters }: IContentSectionLabeledCountersProps) {
  return (
    <div className="flex w-full items-center justify-center space-x-6 font-aeonik xl:w-auto xl:justify-start">
      {counters.map(({ label, totalCount }) => {
        return (
          <div className="space-y-1 text-center" key={label}>
            <h6 className="text-md font-semibold text-gray-700">{totalCount > 99 ? "99+" : totalCount}</h6>
            <span className="inline-flex text-sm font-medium tracking-wide text-gray-500">{label}</span>
          </div>
        );
      })}
    </div>
  );
}

export default ContentSectionLabeledCounters;
